export const COLOR = {
    PRIMARY_MAIN: '#006CFD',
    PRIMARY_DARK: '#004B9F',
    PRIMARY_LIGHT: '#CCE6FA',
    PRIMARY_CONTRAST: '#FFF',
    PRIMARY_LINK: '#006AD8',

    SECONDARY_MAIN: '#FFF',
    SECONDARY_DARK: '#CCE6FA',
    SECONDARY_LIGHT: '#FFF',
    SECONDARY_CONTRAST: '#1B1C1D',

    DISABLED_BG: '#E5E5E7',
    DISABLED_COLOR: '#C0C2C6',

    BUTTON_LOADING_PRIMARY_BG: '#006CFD',
    BUTTON_LOADING_PRIMARY_COLOR: '#FFF',
    BUTTON_LOADING_SECONDARY_BG: '#FFF',
    BUTTON_LOADING_SECONDARY_COLOR: '#1B1C1D',
}
